import { Component, Input } from '@angular/core';
import { Person } from '../../shared/models';

@Component({
    selector: 'person-detail',
    templateUrl: './detail.component.html',
    standalone: false
})
export class PersonDetailComponent {
  @Input() public person: Person;

  public selection: any = {};
  errorMessage: string;

  public loading: Boolean = true;

  constructor() {}
}
